"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingDataSubscriptionData = void 0;
var MissingDataSubscriptionData;
(function (MissingDataSubscriptionData) {
    MissingDataSubscriptionData[MissingDataSubscriptionData["None"] = 0] = "None";
    MissingDataSubscriptionData[MissingDataSubscriptionData["DeliveryAddress"] = 1] = "DeliveryAddress";
    MissingDataSubscriptionData[MissingDataSubscriptionData["BillingAddress"] = 2] = "BillingAddress";
    MissingDataSubscriptionData[MissingDataSubscriptionData["PaymentMethod"] = 3] = "PaymentMethod";
})(MissingDataSubscriptionData = exports.MissingDataSubscriptionData || (exports.MissingDataSubscriptionData = {}));
//# sourceMappingURL=subscription.js.map